module.exports = __webpack_public_path__ + "fonts/BasierSquare-Medium.4eec78d.woff2";